
import { t } from 'i18next';
import { NotificationBellBlue } from '../../../../../assets/images/icons';
import styles from './CreateJobAlert.module.css';

function CreateJobAlert({ job }) {
    return (
        <div className={styles.talentsHeader}>
        <p className={styles.headerTitle}>{t('jobs.createJobAlert')}</p>
        <img
            src={NotificationBellBlue}
            alt={'Notification'}
        />
    </div> 
   )
}

export default CreateJobAlert;